/**
 * This file handles the parallax elements in the background of dynhome-app. We call these items 'flair'!
 */
'use strict';

let blue1 = document.querySelector('.squiggle-blue-1');
let flair1 = document.querySelector('.flair-1');
let flair2 = document.querySelector('.flair-2');
let blue2 = document.querySelector('.squiggle-blue-2');
let pink2 = document.querySelector('.squiggle-pink-2');

let setTranslate = function(xPos, yPos, el) {
	el.style.transform = 'translate3d(' + xPos + ', ' + yPos + 'px, 0)';
};

// let xScrollPosition;
let yScrollPosition;

let scrollLoop = function() {
	// xScrollPosition = window.scrollX;
	yScrollPosition = window.scrollY;

	setTranslate(0, yScrollPosition * -0.2, blue1);
	setTranslate(0, yScrollPosition * -0.8, flair1);
	setTranslate(0, yScrollPosition * -0.7, flair2);
	setTranslate(0, yScrollPosition * -0.5, blue2);
	setTranslate(0, yScrollPosition * -0.4, pink2);

	requestAnimationFrame(scrollLoop);
};

let init = function() {
	scrollLoop();
};

module.exports =  {
	init: init
};
